export const URLS = {
  labelPageSuffix: '/issues/labels',
}
